import { render, staticRenderFns } from "./ListadoSolicitudesModificacionCalificacion.vue?vue&type=template&id=4ebc2241"
import script from "./ListadoSolicitudesModificacionCalificacion.vue?vue&type=script&lang=js"
export * from "./ListadoSolicitudesModificacionCalificacion.vue?vue&type=script&lang=js"
import style0 from "./ListadoSolicitudesModificacionCalificacion.vue?vue&type=style&index=0&id=4ebc2241&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports